import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { SiteLayout } from './components/layout/SiteLayout'
import { HomePage } from './pages/HomePage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ScrollManager } from './components/layout/ScrollManager'
import { AnalyticsTracker } from './features/analytics/AnalyticsTracker'
import { SeoManager } from './components/layout/SeoManager'

const AdminRoute = lazy(() => import('./pages/AdminRoutes').then((module) => ({ default: module.AdminRoute })))
const CatalogPage = lazy(() => import('./pages/CatalogPage').then((module) => ({ default: module.CatalogPage })))
const CatalogDetailPage = lazy(() => import('./pages/CatalogDetailPage').then((module) => ({ default: module.CatalogDetailPage })))
const AdminDemoPreviewRoute = lazy(() => import('./pages/AdminRoutes').then((module) => ({ default: module.AdminDemoPreviewRoute })))
const ContactPage = lazy(() => import('./pages/ContactPage').then((module) => ({ default: module.ContactPage })))
const LegalPage = lazy(() => import('./pages/LegalPage').then((module) => ({ default: module.LegalPage })))
const ShowcasePage = lazy(() => import('./pages/ShowcasePage').then((module) => ({ default: module.ShowcasePage })))
const StudioPage = lazy(() => import('./pages/StudioPage').then((module) => ({ default: module.StudioPage })))

export function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <AnalyticsTracker />
      <SeoManager />
      <Suspense fallback={<main className="route-loader" role="status">Carregando experiência…</main>}><Routes>
          <Route path="/" element={<SiteLayout><HomePage /></SiteLayout>} />
          <Route path="/produtos" element={<SiteLayout><CatalogPage kind="products" /></SiteLayout>} />
          <Route path="/produto/:slug" element={<SiteLayout><CatalogDetailPage kind="product" /></SiteLayout>} />
          <Route path="/demos" element={<SiteLayout><CatalogPage kind="demos" /></SiteLayout>} />
          <Route path="/demo/:slug" element={<SiteLayout><CatalogDetailPage kind="demo" /></SiteLayout>} />
          <Route path="/agroaprendiz" element={<SiteLayout><ShowcasePage project="agroaprendiz" /></SiteLayout>} />
          <Route path="/galaxy" element={<SiteLayout><ShowcasePage project="galaxy" /></SiteLayout>} />
          <Route path="/projetos" element={<SiteLayout><StudioPage kind="projects" /></SiteLayout>} />
          <Route path="/solucoes" element={<SiteLayout><StudioPage kind="solutions" /></SiteLayout>} />
          <Route path="/sobre" element={<SiteLayout><StudioPage kind="about" /></SiteLayout>} />
          <Route path="/contato" element={<SiteLayout><ContactPage /></SiteLayout>} />
          <Route path="/privacidade" element={<SiteLayout><LegalPage kind="privacy" /></SiteLayout>} />
          <Route path="/termos" element={<SiteLayout><LegalPage kind="terms" /></SiteLayout>} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="/admin/preview/demo/:id" element={<AdminDemoPreviewRoute />} />
          <Route path="*" element={<NotFoundPage />} />
      </Routes></Suspense>
    </BrowserRouter>
  )
}
